import { t } from 'i18next'
import React from 'react'

const ItemWithStatusOperable = ({ children, statusColor = '', statusLabel, onCLickEdit, onClickDelete }) => {
    return (
        <div className='white-bg shadow rounded-4 pt-3 pb-3 ps-4 pe-4'>
            <div className='d-flex align-items-center justify-content-between'>
                <div>
                    {children}
                </div>
                <div className='d-flex flex-column justify-content-between align-items-end'>
                    <div className='d-flex gap-2'>
                        <h6
                            className='badge pe-4 ps-4'
                            style={{ background: statusColor }}
                        >
                            {statusLabel}
                        </h6>
                        <div>
                            {
                                onClickDelete ?
                                    <i
                                        onClick={onClickDelete}
                                        type='button'
                                        className="fa-solid fa-xmark"
                                        style={{ color: '#98A0B6' }}
                                    >
                                    </i>
                                    :
                                    null
                            }
                        </div>
                    </div>
                    <div className='pt-3'>
                        {
                            onCLickEdit ?
                                <p
                                    type='button'
                                    onClick={onCLickEdit}
                                    className='m-0 blue-text-tiny'
                                >
                                    {t('EDIT')}
                                </p>
                                :
                                null
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ItemWithStatusOperable